// Palette

import { PRI_400, NTRL_100, PRI_100, PRI_500, PRI_600 } from "../colors";
const radius = "16px";

const style = {
  styleOverrides: {
    contained: {
      padding: "8px 16px",
      borderRadius: radius,
      width: "100%",
      backgroundColor: PRI_500,
      color: NTRL_100,

      "&:hover": {
        backgroundColor: PRI_600,
      },
    },

    outlined: {
      padding: "8px 16px",
      borderRadius: radius,
      width: "100%",
    },
    // containedPrimary: {
    //   backgroundColor: PRI_500,
    // },
  },
};
export default style;
